const TYPES = {
	BOOLEAN:        'boolean',
	/** Название лучше не хватает iq придумать. Суть в том что запись в фиде
	 * будет отображена как "Установлена отметка ..." */
	CUSTOM_BOOLEAN:       'customBoolean',
	OBJECT:               'object',
	NUMBER:               'number',
	NUMBER_PERCENT:       'numberPercent',
	STRING:               'string',
	INT_RANGE:            'intRange',
	DATE_RANGE:           'dateRange',
	DATE:                 'date',
	DATE_TIME:            'dateTime',
	PRICE:                'price',
	TENDER_PRICE:         'tenderPrice',
	TENDER_BID:           'tenderBid',
	SUM:                  'sum',
	PAYMENT_TERM:         'paymentTerm',
	SUPPLY_OFFER:         'supplyOffer',
	MANUFACTURERS:        'manufacturers',
	COORDINATES:          'coordinates',
	TENDER_PARTICIPATION: 'tenderParticipation',
  REFUSAL_REASONS:      'refusalReasons',
  TARIFFS:              'tariffs'
} as const;

export default TYPES;
